import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { AuthProvider } from "./contexts/AuthContext";

import AppRoutes from "./routes/routes";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./app/store";

import "react-phone-number-input/style.css";
import "react-day-picker/style.css";
import "./styles/globals.css";
import "./i18n";
import "./sentry";
import { PersistGate } from "redux-persist/integration/react";
import { DialogProvider } from "react-dialog-async";
import { GeoLocation } from "GeoLocation";
import { HealthCheck } from "Healthcheck";
import BigNumber from "bignumber.js";
import { Toaster } from "./components/ui/sonner";
import { ConfirmProvider } from "./hooks/useConfirm";

const root = ReactDOM.createRoot(document.getElementById("root")!);

BigNumber.config({
  FORMAT: { decimalSeparator: ".", groupSeparator: ",", groupSize: 3 },
});

const WrappedApp = () => {
  return (
    <StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Toaster
            theme="light"
            style={{
              //@ts-ignore
              "--normal-bg": "white",
            }}
          />
          <AuthProvider>
            <DialogProvider>
              <ConfirmProvider>
                <HealthCheck>
                  <GeoLocation>
                    <AppRoutes />
                  </GeoLocation>
                </HealthCheck>
              </ConfirmProvider>
            </DialogProvider>
          </AuthProvider>
        </PersistGate>
      </Provider>
    </StrictMode>
  );
};

root.render(<WrappedApp />);

reportWebVitals();
